import React from 'react';
import { encodeURIComponentFormWWW } from 'src/scripts/utils/helpers';
import { handleNavigationWithArrowKeys, trackRecentSearch } from '../utils';
import { prependLocaleToPath } from '../../../../utils/localization';

const SearchResultList = ({
  searchText,
  productSuggestions,
  isMobileVersion,
}: {
  searchText: string;
  productSuggestions: string[] | undefined;
  isMobileVersion: boolean;
}) => {
  const sanitizeAndBoldSearchText = (value: string) => {
    const regEx = new RegExp(searchText, 'ig');
    return `<span class="search-link-span">${value.replace(
      regEx,
      isMobileVersion ? searchText : `<b>${searchText}</b>`
    )}</span>`;
  };

  return (
    <div className="current-search-block">
      {productSuggestions && <h6 className="header-title h6">Suggestions</h6>}
      <ul className="d-flex ml-0 ">
        {productSuggestions &&
          productSuggestions.map((suggestion: string, index: number) => (
            <li
              className="search-product main-navbar__sub-sub-item search-link"
              key={index}
              tabIndex={-1}
              onKeyDown={(e) => {
                handleNavigationWithArrowKeys(
                  e,
                  prependLocaleToPath(`/search?q=${encodeURIComponentFormWWW(suggestion)}`)
                );
              }}
            >
              <a
                data-link-type="sta_search_suggestion"
                href={`/search?q=${encodeURIComponentFormWWW(suggestion)}`}
                rel="suggestion"
                dangerouslySetInnerHTML={{
                  __html: sanitizeAndBoldSearchText(suggestion),
                }}
                onClick={() => {
                  trackRecentSearch(searchText);
                  window.dataLayer.push({
                    bloomreach_search_suggest_data: {
                      aq: searchText,
                      q: suggestion,
                    },
                  });
                  window.dataLayer.push({ event: 'search_suggestion_click_event' });
                }}
              />
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SearchResultList;
